module.exports = __webpack_public_path__ + "static/media/accountOnReview.4ceaeedf.svg";